import React, { useContext } from "react";
import S from "./MarketValue";
import CardHeader from "../CardHeader";
import FundContext from "@/components/FundSingle/FundProvider";
import Table from "../../../Table/index";
import moment from "moment";

const MarketValue: React.FC<FundSingle> = () => {
  const { portfolio, fundRiskDetails } = useContext(FundContext);

  if (!portfolio) return null;

  if (!portfolio.MarketCapitalBreakdown) return <h1>Missing data</h1>;

  const marketCapitalBreakdowns = portfolio.MarketCapitalBreakdown.find(
    (item: any) => item.SalePosition === "N"
  );
  const marketCapitalBreakdownCategory = fundRiskDetails.Benchmark.find(
    (item: any) => item.Type === "Category"
  ).Portfolios[0].MarketCapitalBreakdown.find(
    (item: any) => item.SalePosition === "N"
  );

  const marketCapitalBreakdownDate = moment(portfolio.Date).format(
    "YYYY-MM-DD"
  );

  const sizeLabels = ["Väldigt stora", "Stora", "Medel", "Små", "Väldigt små"];

  const tableRows: [string, (string | number)[]][] = sizeLabels.map(
    (label, index) => {
      return [
        label,
        [
          marketCapitalBreakdowns.BreakdownValues[index].Value.toFixed(2),
          marketCapitalBreakdownCategory.BreakdownValues[index].Value.toFixed(
            2
          ),
        ],
      ];
    }
  );

  const tableData = {
    headings: ["", "FOND", "KATEGORI"],
    rows: tableRows,
  };

  return (
    <S.AllocationWrapper>
      <CardHeader title="Börsvärde %" subTitle={marketCapitalBreakdownDate} />
      <Table tableData={tableData} />
    </S.AllocationWrapper>
  );
};

export default MarketValue;
